import React, { useState } from "react";
import Button from "../modules/Button";
import MultiSelect from "../modules/MultiSelect";
import DropBtn from "../modules/DropBtn";
import avatar from "../../Assets/svg/avatar-img.svg";
import down from "../../Assets/svg/down arrow new.svg";
import ModalComponent from "../modules/Modal";
import SwitchButton from "../modules/SwitchButton";
import mail from "../../Assets/svg/mail grey icon.svg";
import tick from "../../Assets/svg/green-bg-tick.svg";
import reject from "../../Assets/svg/reject icon.svg";
import Input from "../modules/Input";
import cross from "../../Assets/svg/cross icon.svg";
import notify from "../../Assets/svg/notification icon.svg";
import { useSelector } from "react-redux";
import { api } from "../../Services";

function ConnectionListView(props) {  
  const tokenData = useSelector((state) => state.tokens.tokens);

  const [requestOption, setRequestOption] = useState({
    topic: "",
    comment: "",
  });
  const [modelOptions, setModel] = useState([
    "Resume Building",
    "Job and Internship application",
    "Networking Skills",
    "Job Interviews",
    "Academics",
    "Something else",
  ]);
  const [msg, setMsg] = useState(false);
  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "Request a Session",
    countDown: " ",
    desc: "",
  });
  const [uploading, setUploading] = useState(false);

  const getStatus = (type) => {
    if (type === "Pending") {
      return (
        <div className="status pending">
          Pending
          <img src={notify} alt="tick" />
        </div>
      );
    } else if (type === "Completed" || type === "Accepted") {
      return (
        <div className="status completed">
          {type}
          <img src={tick} alt="tick" />
        </div>
      );
    } else if (type === "Decline") {
      return (
        <div className="status declined">
          Declined
          <img src={cross} alt="tick" />
        </div>
      );
    } else {
      return <div className="status progress">In Progress</div>;
    }
  };
  const showMsg = (info) => {
    if ((props?.item?.requestStatus || props?.item?.status) === "Decline") {
      return (
        <div className="sentence">
          <span className="upload-top-text">Reason for Decline</span>

          {info?.requestRejectionReason?.split("\n").map((paragraph, index) => (
            <span className="sub-option-text" key={index}>
              {paragraph}
            </span>
          ))}
        </div>
      );
    } else {
      return (
        <div className="sentence">
          {info?.message?.split("\n").map((paragraph, index) => (
            <span className="sub-option-text" key={index}>
              {paragraph}
            </span>
          ))}
        </div>
      );
    }
  };
  const [concern, setConcern] = useState("");

  const sendData = (type) => {
    props.setCallType(type);
    props.setId(props?.item?.requestId);
  };
  const cancelSession = (type) => {
    sendData(type);
    props.setModalData({
      ...props.ModalData,
      type: "cancel",
      show: true,
      desc: "",
      title: "Do you want to cancel the session?",
    });
  };
  const feedback = (type) => {
    sendData(type);
    props.setModalData({
      ...props.ModalData,
      type: "rating",
      show: true,
      title: "How was your experience?",
      desc: "We would love to know more about your mentorship session",
    });
  };
  const sendReq = (type) => {
    sendData(type);
    // setModalData({
    //   show: true,
    //   type: "confirm",
    //   title: "Request a Session",
    //   countDown: " ",
    //   desc: "",
    // });
    props.setModalData({
      ...ModalData,
      show: true,
      type: "request",
      title: "Request a Session",
    });
  };

  const takeRequest = () => {
    // let item = scholars.filter((a) => a.applicationId === id)[0];

    return (
      <div className="feedback-content">
        <div className="mentor-info">
          <div className="image img-section">
            {/* <img src={avatar} alt="avatar" /> */}
            {props.item?.image && props.item?.imageExtension && (
              <img
                // className="image"
                src={
                  props.item?.image && props.item?.imageExtension
                    ? "data:image/" +
                      props.item?.imageExtension +
                      ";base64," +
                      props.item?.image
                    : null
                }
                alt="Preview"
                // style={{ maxWidth: "100%", height: "100%" }}
              />
            )}
          </div>
          <div
            className="mentor-text"
            style={{ marginLeft: "2%", justifyContent: "space-between" }}
          >
            <span className="set-title">
              {props.item?.name || props?.item?.fullName}
            </span>
            <span className="md-desc" style={{ color: "#222222" }}>
              {props.item?.name || props?.item?.fullName}
            </span>
          </div>
        </div>

        <div className="comment-field">
          <Input
            onChange={(e) => setConcern(e.replace(/[^a-zA-Z0-9. ]/g, ""))}
            placeholder={"Could you tell us a little more?"}
            multiline={true}
          />
        </div>
        <div className="cred-btn">
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"Cancel"}
            type={"outlined"}
          />
          <Button
            onClickHandler={() => checkRequest()}
            value={"Connect"}
            type={"contained"}
          />
        </div>
      </div>
    );
  };

  const makeRequest = async () => {
    // console.log("in checkModified after timer");
    // let noNullData=replaceNullsWithEmptyStrings(cleanObjectStrings(CombineData()))
    let data = {
      senderApplicationId: tokenData.applicationData.id,
      receiverApplicationId: props.item?.id,
      isReceiverAlumni: false,
      message: concern,
    };

    try {
      const request = await api.sendAlumniRequest(tokenData.token, data);
      console.log("users", request);
      return request;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const checkRequest = async () => {
    setUploading(true);
    try {
      const request = await makeRequest();
      console.log("users", request);
      setUploading(false);
      if (request.statusCode == 200) {
        setModalData({
          ...ModalData,
          type: "submit",
          title: (
            <div className="set-title">
              <div className="happy-icon">
                <img src={tick} alt="tick" />
              </div>
              Connection request sent!
            </div>
          ),
          desc: "You’ll be notified once your fellow Scholar accepts the request",
        });
      }
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      setUploading(false);

      // Handle error scenario
    }
    // setModified(false);
    // }
  };

  return (
    <div className="certificate">
      {/* <div className="image img-section">
        <img src={avatar} alt="avatar" />
      </div> */}
      <div className="image img-section">
        {/* <img src={avatar} alt="avatar" /> */}
        {props.item?.image && props.item?.imageExtension && (
          <img
            // className="image"
            src={
              props.item?.image && props.item?.imageExtension
                ? "data:image/" +
                  props.item?.imageExtension +
                  ";base64," +
                  props.item?.image
                : null
            }
            alt="Preview"
            // style={{ maxWidth: "100%", height: "100%" }}
          />
        )}
      </div>
      <div className="mentor-section">
        <div className="mentor-top">
          <div className="mentor-left">
            <span className="md-title">
              {props?.item?.fullName || props.item?.name}
            </span>
            <span className="role">{props?.item?.expertise}</span>
            {/* <div className="skill-section">
              <div className="skill-item">PGDM, 2023-25</div>
              <div className="skill-item">Bengaluru, Karnataka</div>
            </div> */}
            {(props?.item?.requestStatus === "Accepted" || props?.item?.status === "Accepted")&& (
                <div className="mail-line">
                  <div className="mail-icon">
                    <img src={mail} alt="mail" />
                  </div>
                  <span className="role-text">{props?.item?.email}</span>
                </div>
              )}
            {/* <div
              className={`skill-section dynamic-skill-section ${
                msg ? "show-msg" : ""
              }`}
              onClick={() => setMsg(!msg)}
            >
              <span className="skill subTitle">Resume</span>
              <img src={down} alt="down" />
            </div> */}
            {/* <div className="btn-section">
            
            <Button
              onClickHandler={() => setMsg(!msg)}
              value={
                <div className={`msg-view-btn ${msg ? "hide" : "show"}`}>
                  <img src={down} alt="down" />
                  <span>{msg ? "hide message" : "view message"}</span>
                </div>
              }
              type={"only-text"}
            />
          </div> */}
            {/* {msg && (
              <div className="sentence">
                {data.split("\n").map((paragraph, index) => (
                  <span className="sub-option-text" key={index}>
                    {paragraph}
                  </span>
                ))}
              </div>
            )} */}
          </div>
          <div className="mentor-right">
            <div className="right-top">
              <span className="sub-option-text">{props?.item?.date}</span>
              {getStatus(props?.item?.requestStatus || props?.item?.status)}
            </div>
            <div className="right-btm">
              {/* {(props?.item?.requestStatus || props?.item?.status) ===
                "Completed" && (
                <Button
                  onClickHandler={() => feedback("feedback")}
                  value={"Rate your experience"}
                  type={"outlined"}
                />
              )} */}
              {(props?.item?.requestStatus || props?.item?.status) ===
              "Pending" ? (
                <Button
                  onClickHandler={() => cancelSession("Cancel")}
                  value={"Cancel Request"}
                  type={"only-text"}
                />
              ) : (
                ((props?.item?.requestStatus || props?.item?.status) ===
                  "Completed" ||
                  (props?.item?.requestStatus || props?.item?.status) ===
                    "Decline") && (
                  <Button
                    onClickHandler={() => sendReq("Request again")}
                    value={"Request again"}
                    type={"only-text"}
                  />
                )
              )}
            </div>
            {/* <div className="sub-option-text">May 17, Fri</div>
          
          </div> */}
            {/* <div className="skill-section">
      <span className="skill subTitle">Resume Building</span>
      <img src={down} alt="down" />
    </div> */}
          </div>
        </div>
        <div className="mentor-btm">
          {
            (props?.item?.message || props?.item?.requestRejectionReason) &&
            showMsg(props?.item)}
        </div>
      </div>
      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          content={ModalData.desc}
          className={"mentor-request mentor"}
          noCross={
            (ModalData.type === "submit" || ModalData.type === "network") &&
            true
          }

          // countDown={ModalData.countDown}
        >
          {ModalData.type === "confirm" ? (
            takeRequest()
          ) : (
            <Button
              onClickHandler={() =>
                setModalData({
                  ...ModalData,
                  type: "network",
                  title: "",
                  desc: "",
                })
              }
              value={"Okay"}
              type={"contained"}
            />
          )}
        </ModalComponent>
      )}
    </div>
  );
}

export default ConnectionListView;
